/**
 * @file 飞桨AI For Science共创计划
 * @author v_duzhengqiang
 */
import React from 'react';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';

import EasyDeployHeader from './components/easyDeployHeader/EasyDeployHeader';
import DeploymentOfAbility from './components/deploymentOfAbility/DeploymentOfAbility';
import AbilityToOverview from './components/abilityToOverview/AbilityToOverview';
import ApplicationScenarios from './components/applicationScenarios/ApplicationScenarios';
import ModelCovering from './components/modelCovering/ModelCovering';
import HardwareCoverage from './components/hardwareCoverage/HardwareCoverage';
import EasyDeployFotter from './components/easyDeployFotter/EasyDeployFotter';



import useEasyDeployHooks from './easyDeployHooks';


const EasyDeploy: React.FC = () => {

    const {
        data
    } = useEasyDeployHooks();

    return (
        <div>
            <Header />
            <div className="easy_deploy">
                {/* 头部 */}
                <EasyDeployHeader {...data.easyDeployHeader}/>
                {/*能力概览 */}
                <AbilityToOverview {...data.abilityToOverview} />
                 {/* 部署能力 */}
                <DeploymentOfAbility {...data.deploymentOfAbility}/>
                {/* 应用场景 */}
                <ApplicationScenarios {...data.applicationScenarios} />
                {/* 模型覆盖 */}
                <ModelCovering {...data.modelCovering}/>
                {/* 硬件覆盖 */}
                <HardwareCoverage {...data.hardwareCoverage} />
                {/* 使用咨询 */}
                <EasyDeployFotter
                
                 easyDeployFotter = {data.easyDeployFotter}
                 qrCode= {data.qrCode}
                />
            </div>

            <Footer />
        </div>
    );
};

export default React.memo(EasyDeploy);
